import React, { Fragment, useState } from 'react';
import { 
  Button, Typography, Divider,
  Card, CardHeader, CardContent, 
  Grid, Paper, Box,
  Dialog, DialogActions, DialogContent, 
  DialogContentText, DialogTitle
} from '@material-ui/core';
import Breadcrumbs from '../core/controls/components/breadcrumbs';
import { getEnvVariable } from '../modules/environmentalList.js';
import { GetData } from '../core/controls/helpers/requests';
import DefaultSettings from '../core/controls/components/settings';
 
const breadcrumbs = {
    type: 'breadcrumbs',
    items: [
        { "link": "Site Settings", "tab": 'D', "materialicon": "dashboard", href: getEnvVariable('AccessPortal') === 'I' ? getEnvVariable('InternalBasepath') : getEnvVariable('ExternalBasepath'), className: 'breadcrumb-item text-dark', class: 'text-dark' },
        { "link": "Invoice Settings List", href: "/Administration/invoicepermitrenewals", "materialicon": "local_atm", className: 'breadcrumb-item ', class: '' }
    ],
}
 
export default function InvoicePermitRenewals(){
    const [isProcessing, setIsProcessing] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogConfig, setDialogConfig] = useState({
        title: "",
        content: "",
        confirmAction: null
    });
    
    const showConfirmation = (title, content, confirmAction) => {
        setDialogConfig({
            title: title,
            content: content,
            confirmAction: confirmAction
        });
        setDialogOpen(true);
    };

    const handleConfirm = () => {
        setDialogOpen(false);
        if (dialogConfig.confirmAction) {
            dialogConfig.confirmAction();
        }
    };

    const handleCancel = () => {
        setDialogOpen(false);
    };
    
    const RunPermitRenewalInvoice = () => {
        setIsProcessing(true);
        let url = getEnvVariable('Payment') + `InvoiceCycleRun/YearlyInvCycleRun`;

        GetData(url, '', true).then(resp => {
            if (resp) {
                DefaultSettings.getAlert().show('Permit renewal invoice run successfully.', 'info');
            }
            setIsProcessing(false);
        });
    }

    const RunRenewalInvoiceNotification = () => {
        setIsProcessing(true);
        let url = getEnvVariable('Payment') + `InvoiceCycleRun/InvoiceNotificationsRun`;

        GetData(url, '', true).then(resp => {
            if (resp) {
                DefaultSettings.getAlert().show('Permit Renewal invoice Notification run successfully.', 'info');
            }
            setIsProcessing(false);
        });
    }


    const RunPermitReminderOrCancelInvoice = (reminderType) => {
        setIsProcessing(true);
        let url = getEnvVariable('Payment') + `InvoiceCycleRun/ReminderInvoicesRun`;

        GetData(url, '', true).then(resp => {
            if (resp && DefaultSettings.getAlert() != null) {
                if(reminderType === 1){
                    DefaultSettings.getAlert().show('Permit Reminder invoice run successfully.', 'info');
                } else {
                    DefaultSettings.getAlert().show('Permit Cancel invoice run successfully.', 'info');
                }
            }
            setIsProcessing(false);
        });
    }
 
    return (
        <Fragment>
            <div className="d-flex application-border my-2 p-0">
                <Breadcrumbs {...breadcrumbs} className="pt-2" />
            </div>
            <div className="application-border mb-1">
            <Card>
                <CardHeader 
                    title="Invoice & Permit Management" 
                    subheader="Run invoice and permit processes for renewals, reminders, and cancellations"
                />
                <Divider />
                <CardContent>
                    <Grid>
                        {/* Batch invoice processes section */}
                        <Grid item xs={12}>
                            <Paper elevation={1}>
                                <Box p={3}>
                                    <Typography variant="h6" gutterBottom>
                                        Renewal Processes
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" paragraph>
                                        Generate permit renewal invoices and send notifications
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Button 
                                                variant="contained" 
                                                color="primary" 
                                                onClick={() => showConfirmation(
                                                    "Generate Renewal Invoices",
                                                    "Are you sure you want to generate permit renewal invoices? This process may take several minutes to complete.",
                                                    RunPermitRenewalInvoice
                                                )}
                                                disabled={isProcessing}
                                                fullWidth
                                            >
                                                Generate Renewal Invoices
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Button 
                                                variant="contained" 
                                                color="primary" 
                                                onClick={() => showConfirmation(
                                                    "Send Renewal Notifications",
                                                    "Are you sure you want to send renewal notifications to all applicable permit holders?",
                                                    RunRenewalInvoiceNotification
                                                )}
                                                disabled={isProcessing}
                                                fullWidth
                                            >
                                                Send Renewal Notifications
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Paper>
                        </Grid>

                        {/* Reminders and Cancellations section */}
                        <Grid item xs={12}>
                            <Paper elevation={1}>
                                <Box p={3}>
                                    <Typography variant="h6" gutterBottom>
                                        Reminders & Cancellations
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" paragraph>
                                        Send payment reminders or cancel outstanding invoices and permits
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Button 
                                                variant="contained" 
                                                color="secondary" 
                                                onClick={() => showConfirmation(
                                                    "Send Payment Reminders",
                                                    "Are you sure you want to send payment reminders for all outstanding invoices?",
                                                    () => RunPermitReminderOrCancelInvoice(1)
                                                )}
                                                disabled={isProcessing}
                                                fullWidth
                                            >
                                                Send Payment Reminders
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Button 
                                                variant="contained" 
                                                color="secondary" 
                                                onClick={() => showConfirmation(
                                                    "Cancel Invoices & Permits",
                                                    "WARNING: This will cancel all eligible unpaid invoices and their associated permits. This action cannot be undone. Are you sure you want to continue?",
                                                    () => RunPermitReminderOrCancelInvoice(2)
                                                )}
                                                disabled={isProcessing}
                                                fullWidth
                                            >
                                                Cancel Invoices & Permits
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            </div>

            {/* Confirmation Dialog */}
            <Dialog
                open={dialogOpen}
                onClose={handleCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{dialogConfig.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialogConfig.content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} color="primary" variant="contained" autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}